import { injectable } from 'tsyringe';
import type { ResourceLoader } from '../../domain/help-center/ResourceLoader';

@injectable()
export class WindowResourceLoader implements ResourceLoader {
  async open(url: string): Promise<void> {
    window.open(url, '_blank', 'noopener');
  }
}
